<template>
  <v-container>
    <v-layout row align-center justify-space-between>
      <v-flex xs6 sm6 md6 px-1>
        <v-select
          label="並び替え"
          color="accent"
          item-text="label"
          item-value="value"
          :items="sortItems"
          @change="changeSort"
          return-object
        />
      </v-flex>
      <v-flex xs6 sm6 md6 px-1>
        <v-select
          label="順序"
          color="accent"
          item-text="label"
          item-value="value"
          :items="order"
          @change="changeOrder"
          return-object
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import GraphListUtils from "@/components/common/GraphListUtils.js";

export default {
  props: {
    mypage_flg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSortType: true,
      categories: [],
      sortItems: [],
      order: [],
      selectedSortKey: "access_count",
      selectedOrder: -1
    };
  },
  mounted() {
    const sortItemlist = GraphListUtils.convertJsonToGraphListObject();
    this.setSortItems(sortItemlist);
    this.setSortOrder(sortItemlist);
  },
  methods: {
    setSortItems(list) {
      this.sortItems = list.sort.map(s => {
        return {
          label: s.name,
          value: s.id
        };
      });
      if(this.mypage_flg) {
        this.sortItems.push({ label: '作成日時', value: 4 });
      }
    },
    setSortOrder(list) {
      this.order = list.type.map(type => {
        return {
          label: type.name,
          value: type.id
        };
      });
    },
    changeSort(sort) {
      switch (sort.value) {
      // アクセス数順
      case 1:
        this.selectedSortKey = "access_count";
        break;
      // イイネ順
      case 2:
        this.selectedSortKey = "used_count";
        break;
      // シェア順
      case 3:
        this.selectedSortKey = "heart_count";
        break;
      // 作成日時順
      case 4:
        this.selectedSortKey = "created_date";
        break;
      default:
        console.error("Sort key is not found.");
      }

      this.fireEmit();
    },
    changeOrder(order) {
      // 降順
      if(order.value === 1) {
        this.selectedOrder = 1;
      // 昇順
      } else {
        this.selectedOrder = -1;
      }
      this.fireEmit();
    },
    fireEmit() {
      this.$emit("sort", this.selectedSortKey, this.selectedOrder);
    }

  }
}
</script>
